import React from 'react';
import { useSubscription } from '../../hooks/useSubscription';
import { tierConfig } from './headerConstants';

/**
 * Small subscription tier badge
 */
export function SubscriptionBadge() {
  const { tier } = useSubscription();
  const config = tierConfig[tier] || tierConfig.free;

  return (
    <span
      className={`text-xs px-2 py-0.5 rounded-full ${config.color}`}
      data-testid="subscription-badge"
    >
      {config.emoji} {config.label}
    </span>
  );
}
